module.exports = __webpack_public_path__ + "media/images/img-pet-1-d6fa9135.jpg";